<!-- Created by henian.xu on 2020/4/7. -->

<template>
    <Page>
        <Container>
            <div
                v-if="errorMsg"
                class="ma-tb pa-ab ta-c tc-danger"
            >{{ errorMsg }}</div>
            <div
                v-else
                class="ma-tb pa-ab ta-c tc-danger">
                <XImage
                    :src="$loadingIcon"
                    width="20%"
                ></XImage>
            </div>
        </Container>
    </Page>
</template>

<script>
import { pageMixin } from 'mixins/index';

export default {
    name: 'ResultPage',
    mixins: [pageMixin],
    data() {
        return {
            code: this.$route.params.code,
            transferInfo: {},
            errorMsg: '',
        };
    },
    methods: {
        async getDetail() {
            const { code } = this;
            try {
                const { data } = await this.$api.Member.Mb.Member.getWeixinPayTransferInfo({ code });
                this.transferInfo = data;
                await this.$wxSDK.requestMerchantTransfer(data);
                this.$router.replace('/');
            } catch (e) {
                this.errorMsg = e.message;
                console.log(e.message);
            }
        },
    },
    created() {
        this.getDetail();
    },
};
</script>

<style lang="scss" scoped>
.status {
    text-align: center;
    background-color: $color-component-bgc;
    padding: $padding-big * 3 $padding-big;
    margin-bottom: $margin;
    > .label {
        margin-top: $margin-big;
    }
}
</style>
